import { ComponentPortal, DomPortalOutlet } from '@angular/cdk/portal';
import {
  ApplicationRef,
  ComponentRef,
  Injectable,
  Injector
} from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { LoaderComponent } from '~/shared/modules/loader/loader.component';
import { getComponentRootNode } from '../infrastructure/get-component-root-node';
import { PacerManagerService } from './pacer-manager';

@Injectable({ providedIn: 'root' })
export class PacerService {
  private _pacing: boolean;
  private _changes = new Subject();
  private _el: HTMLElement;
  private _counter = 0;

  constructor(
    private _appRef: ApplicationRef,
    private _injector: Injector,
    private _pacerManagerService: PacerManagerService
  ) {
    const el = (this._el = document.createElement('div'));
    el.classList.add('loading-overlay');

    const portalHost = new DomPortalOutlet(
      el,
      _appRef,
      _injector
    );
    const portal = new ComponentPortal(LoaderComponent);
    const componentRef: ComponentRef<LoaderComponent> = portalHost.attachComponentPortal(
      portal
    );

    const rootNode = getComponentRootNode(componentRef);
    rootNode.classList.add('md');

    document.body.appendChild(el);
  }

  /**
   * Emits when the pacing state changes.
   */
  get changes(): Observable<any> {
    return this._changes;
  }

  /**
   * Gets whether the pacing state is active.
   */
  get pacing() {
    return this._pacing;
  }

  /**
   * Activate the pacing state.
   */
  start(savingMode?: boolean,saveFocus?:boolean,custommessage:any = null) {
    let mode = savingMode ? 'saving' : 'fetching';
    let allmode = {mode:mode,message:custommessage} ;
    this._pacerManagerService.setPacerModeChanges(allmode);

    this._counter++;
     if (!saveFocus) {
      this._unfocusActiveElement();
 }
    this._pacing = true;
    this._handleUpdate();
  }

  /**
   * Deactivate the pacing state.
   */
  stop() {
    this._counter--;

    if (this._counter < 0) {
      console.debug('Pacer counter reached negative state. Resetting.');
      this._counter = 0;
      return;
    }

    if (this._counter != 0) {
      return;
    }

    this._pacing = false;
    this._handleUpdate();
    this._pacerManagerService.setPacingChanges(false);
  }

  private _handleUpdate() {
    this._changes.next(null);

    if (this.pacing) {
      this._el.classList.add('active');
    } else {
      this._el.classList.remove('active');
    }
  }

  private _unfocusActiveElement() {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  }
}
